import { c as create_ssr_component, i as is_promise, n as noop, b as add_attribute, v as validate_component, e as escape, a as subscribe, d as each } from "../../chunks/ssr.js";
import { E as EditorToolbar_1, P as PlainText } from "../../chunks/PlainText.js";
import { R as RichText } from "../../chunks/RichText.js";
import { S as SecondaryButton } from "../../chunks/SecondaryButton.js";
import { W as WebsiteNav } from "../../chunks/WebsiteNav.js";
import { F as Footer } from "../../chunks/Footer.js";
import { N as NotEditable } from "../../chunks/NotEditable.js";
import { c as classNames, f as formatDate } from "../../chunks/util.js";
import { p as page } from "../../chunks/stores.js";
import "../../chunks/client.js";
const Image = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { editable } = $$props;
  let { src } = $$props;
  let { alt } = $$props;
  let { uploadPrompt = void 0 } = $$props;
  let { maxWidth } = $$props;
  let { maxHeight } = $$props;
  let { quality } = $$props;
  let { class: className = "" } = $$props;
  let previewSrc;
  if ($$props.editable === void 0 && $$bindings.editable && editable !== void 0)
    $$bindings.editable(editable);
  if ($$props.src === void 0 && $$bindings.src && src !== void 0)
    $$bindings.src(src);
  if ($$props.alt === void 0 && $$bindings.alt && alt !== void 0)
    $$bindings.alt(alt);
  if ($$props.uploadPrompt === void 0 && $$bindings.uploadPrompt && uploadPrompt !== void 0)
    $$bindings.uploadPrompt(uploadPrompt);
  if ($$props.maxWidth === void 0 && $$bindings.maxWidth && maxWidth !== void 0)
    $$bindings.maxWidth(maxWidth);
  if ($$props.maxHeight === void 0 && $$bindings.maxHeight && maxHeight !== void 0)
    $$bindings.maxHeight(maxHeight);
  if ($$props.quality === void 0 && $$bindings.quality && quality !== void 0)
    $$bindings.quality(quality);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${editable ? `${function(__value) {
      if (is_promise(__value)) {
        __value.then(null, noop);
        return ` <img${add_attribute("class", className, 0)}${add_attribute("src", previewSrc || src, 0)}${add_attribute("alt", alt, 0)}> `;
      }
      return function(ImageEditor) {
        return ` ${validate_component(ImageEditor.default, "ImageEditor.default").$$render(
          $$result,
          {
            class: className,
            alt,
            uploadPrompt,
            maxWidth,
            maxHeight,
            quality,
            src,
            previewSrc
          },
          {
            src: ($$value) => {
              src = $$value;
              $$settled = false;
            },
            previewSrc: ($$value) => {
              previewSrc = $$value;
              $$settled = false;
            }
          },
          {}
        )} `;
      }(__value);
    }(import("../../chunks/ImageEditor.js"))}` : `<img${add_attribute("width", maxWidth, 0)}${add_attribute("height", maxHeight, 0)}${add_attribute("class", className, 0)}${add_attribute("src", src, 0)}${add_attribute("alt", alt, 0)}>`}`;
  } while (!$$settled);
  return $$rendered;
});
const PostTeaser = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let teaser_image;
  let { post } = $$props;
  let { currentUser } = $$props;
  const lf = new Intl.ListFormat("en");
  if ($$props.post === void 0 && $$bindings.post && post !== void 0)
    $$bindings.post(post);
  if ($$props.currentUser === void 0 && $$bindings.currentUser && currentUser !== void 0)
    $$bindings.currentUser(currentUser);
  teaser_image = JSON.parse(post.teaser_image);
  return `<div${add_attribute("href", `/posts/${post.slug}`, 0)}${add_attribute("class", classNames("md:text-xl rounded-2xl border bg-white p-4 sm:p-8 border-gray-200"), 0)}><div>${currentUser ? `<div class="text-sm py-2 flex"><div class="flex-1"> ${post.is_public ? `<strong data-svelte-h="svelte-93tr8l">Public</strong> ${post.recipients.length > 0 ? `(and sent to ${escape(lf.format(post.recipients.map((r) => r.name)))})` : ``}` : `${post.recipients.length > 0 ? `<strong data-svelte-h="svelte-btrp8h">Shared</strong> (sent to ${escape(lf.format(post.recipients.map((r) => r.name)))})` : `Private`}`}</div> ${post.is_public ? `<div title="This post is publicly visible." data-svelte-h="svelte-1c8jlnx"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"></path></svg></div>` : ``}</div>` : ``} <div><a${add_attribute("href", `/posts/${post.slug}`, 0)}${add_attribute("class", classNames("text-2xl md:text-3xl lg:text-4xl font-bold"), 0)}>${escape(post.title)}</a></div> ${teaser_image?.src && teaser_image?.width && teaser_image?.height ? `<a${add_attribute("href", `/posts/${post.slug}`, 0)}><img class="block w-full mt-4"${add_attribute("src", teaser_image.src, 0)}${add_attribute("width", teaser_image.width, 0)}${add_attribute("height", teaser_image.height, 0)}${add_attribute("alt", post.title, 0)}></a>` : ``} <div class="pt-4"><div${add_attribute("class", teaser_image?.src ? "line-clamp-3" : "line-clamp-5", 0)}><a${add_attribute("href", `/posts/${post.slug}`, 0)}><span class="font-bold">${escape(formatDate(post.created_at))}</span> — ${escape(post.teaser)}</a></div></div></div> <div class="pt-4 flex">${validate_component(SecondaryButton, "SecondaryButton").$$render($$result, { size: "sm", href: `/posts/${post.slug}` }, {}, {
    default: () => {
      return `Continue reading →`;
    }
  })}</div></div>`;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let currentUser;
  let postLimit;
  let $page, $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  let { data } = $$props;
  let editable, name, avatar, bio;
  let searchInput;
  let searchFilter = data.searchFilter;
  let showMenu;
  function initOrReset() {
    avatar = data.bio.avatar;
    name = data.bio.name;
    bio = data.bio.bio;
    editable = false;
  }
  initOrReset();
  if ($$props.data === void 0 && $$bindings.data && data !== void 0)
    $$bindings.data(data);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    currentUser = data.currentUser;
    postLimit = $page.url.searchParams.get("postLimit") || 30;
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-1iyhcmr_START -->${$$result.title = `<title>${escape(name)}</title>`, ""}<meta name="description"${add_attribute("content", bio, 0)}><meta name="og:title" property="og:title"${add_attribute("content", name, 0)}><meta name="og:description" property="og:description"${add_attribute("content", bio, 0)}><meta name="og:image" property="og:image" content="%sveltekit.assets%/favicon/favicon-512x512.png"><meta name="twitter:card" content="summary"><meta name="twitter:title"${add_attribute("content", name, 0)}><meta name="twitter:description"${add_attribute("content", bio, 0)}><meta name="twitter:image" content="%sveltekit.assets%/favicon/favicon-512x512.png"><meta name="robots" content="index, follow"><link href="/feed.xml" rel="alternate" type="application/rss+xml"${add_attribute("title", name, 0)}><link rel="icon" type="image/png" sizes="300x300"${add_attribute("href", avatar, 0)}><link rel="apple-touch-icon" sizes="300x300"${add_attribute("href", avatar, 0)}><!-- HEAD_svelte-1iyhcmr_END -->`, ""} ${editable ? `${validate_component(EditorToolbar_1, "EditorToolbar").$$render($$result, {}, {}, {})}` : ``} ${validate_component(WebsiteNav, "WebsiteNav").$$render(
      $$result,
      {
        bio: { avatar, name, bio },
        editable,
        showMenu
      },
      {
        editable: ($$value) => {
          editable = $$value;
          $$settled = false;
        },
        showMenu: ($$value) => {
          showMenu = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `${currentUser ? `<div class="space-y-4 flex flex-col">${validate_component(SecondaryButton, "SecondaryButton").$$render($$result, { size: "sm" }, {}, {
            default: () => {
              return `Edit Profile`;
            }
          })}</div>` : ``}`;
        }
      }
    )}  <div class="__bio"><div class="max-w-screen-md mx-auto px-6"><div class="pt-6 sm:pt-12 pb-2 sm:pb-6 text-center"><div class="w-20 h-20 md:w-28 md:h-28 mx-auto overflow-hidden relative rounded-full">${validate_component(Image, "Image").$$render(
      $$result,
      {
        class: "block w-20 h-20 md:w-28 md:h-28 rounded-full",
        maxWidth: "384",
        maxHeight: "384",
        quality: "0.8",
        editable,
        alt: name,
        src: avatar
      },
      {
        src: ($$value) => {
          avatar = $$value;
          $$settled = false;
        }
      },
      {}
    )}</div></div> <div class=""><h1 class="text-center text-3xl md:text-6xl font-bold">${validate_component(PlainText, "PlainText").$$render(
      $$result,
      { editable, content: name },
      {
        content: ($$value) => {
          name = $$value;
          $$settled = false;
        }
      },
      {}
    )}</h1></div> <div class="prosa text-center py-4 sm:text-xl">${validate_component(RichText, "RichText").$$render(
      $$result,
      { editable, content: bio },
      {
        content: ($$value) => {
          bio = $$value;
          $$settled = false;
        }
      },
      {}
    )}</div></div></div> ${validate_component(NotEditable, "NotEditable").$$render($$result, { editable }, {}, {
      default: () => {
        return ` <div class="max-w-screen-md mx-auto px-6 pt-4 lg:pt-8"><div${add_attribute("class", classNames(data.searchQuery ? "" : "", "relative"), 0)}>${!data.searchQuery && !data.searchFilter ? `<div class="pointer-events-none absolute inset-y-0 left-3 flex items-center" data-svelte-h="svelte-u6bpx3"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"></path></svg></div>` : `<a href="/" class="absolute inset-y-0 left-3 flex items-center" data-svelte-h="svelte-1eoggm0"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"></path></svg></a>`} <input${add_attribute("value", data.searchQuery, 0)} autocomplete="off" id="search" name="search" class="block w-full rounded-full border-1 border-gray-200 bg-transparent py-2 pl-10 pr-24 placeholder-gray-400 focus:border-black focus:text-black focus:outline-none focus:ring-0"${add_attribute("placeholder", `Search ${data.posts.length} posts`, 0)} type="text"${add_attribute("this", searchInput, 0)}> ${currentUser ? `<div class="absolute inset-y-0 right-3 pt-[5px]"><select id="country" name="country" autocomplete="country-name" class="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-0 ring-inset focus:ring-1 focus:ring-inset focus:ring-gray-200 sm:max-w-xs sm:text-sm leading-4"><option value="" data-svelte-h="svelte-6oaaoo">Show all</option><option value="private" data-svelte-h="svelte-1biwgrw">Private</option><option value="public" data-svelte-h="svelte-56kvny">Public</option></select></div>` : ``}</div></div> <div id="posts">${data.posts.length === 0 ? `<div class="max-w-screen-md mx-auto px-6 pt-4 lg:pt-8"><div class="md:text-xl py-4 text-center">${!data.searchQuery && !searchFilter ? `${currentUser ? ` <a class="underline" href="#" data-svelte-h="svelte-1qys71n">Personalise</a> your
              profile, then <a class="underline"${add_attribute("href", "/posts/new", 0)} data-svelte-h="svelte-1ipdxsq">create</a> your first post 💌` : ` <a href="#" class="underline" data-svelte-h="svelte-kd3i3s">Sign in</a> to start writing.`}` : `No posts found.`}</div></div>` : ``} <div class="max-w-screen-md mx-auto px-6"><div class="my-6 space-y-8">${each(data.posts.slice(0, postLimit), (post) => {
          return `${validate_component(PostTeaser, "PostTeaser").$$render($$result, { post, currentUser }, {}, {})}`;
        })}</div></div> ${postLimit < data.posts.length ? `<div class="max-w-screen-md mx-auto px-6 pb-6"><button class="w-full mx-auto block px-4 py-2 rounded-lg border shadow-md bg-white text-center uppercase font-medium" data-svelte-h="svelte-akznku">Show more</button></div>` : ``}</div>`;
      }
    })} ${validate_component(Footer, "Footer").$$render($$result, { counter: "/", editable }, {}, {})}`;
  } while (!$$settled);
  $$unsubscribe_page();
  return $$rendered;
});
export {
  Page as default
};
